import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { Eye, X } from "lucide-react";
import api from "../lib/api";

export default function LiveViewersButton({ streamId, fallback = 0, className = "" }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!streamId) return undefined;
    let alive = true;
    const tick = () => api.get(`/live/${streamId}/viewers`).then(r => { if (alive) setData(r.data); }).catch(() => {});
    tick();
    const t = setInterval(tick, 4000);
    return () => { alive = false; clearInterval(t); };
  }, [streamId]);
  const count = data?.count ?? fallback ?? 0;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="live-viewers-btn"
        className={`px-2.5 py-1 rounded-full bg-black/60 backdrop-blur text-xs flex items-center gap-1 active:scale-95 ${className}`}>
        <Eye className="w-3.5 h-3.5"/><span data-testid="live-viewers-count">{count}</span>
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[90] max-w-md mx-auto" data-testid="live-viewers-sheet">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)}/>
          <div className="absolute bottom-0 inset-x-0 bg-[#0B0F19] rounded-t-3xl border-t border-white/10 max-h-[65vh] flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <h3 className="font-outfit font-bold">Viewers · {count}</h3>
              <button type="button" onClick={() => setOpen(false)} data-testid="live-viewers-close" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center"><X className="w-4 h-4"/></button>
            </div>
            <div className="overflow-y-auto p-2">
              {(data?.viewers || []).length === 0 && <p className="p-6 text-center text-sm text-white/55">No viewers yet</p>}
              {(data?.viewers || []).map(v => (
                <Link key={v.id} to={`/u/${v.id}`} data-testid={`live-viewer-${v.id}`} className="flex items-center gap-3 p-2 rounded-xl active:bg-white/5">
                  <img src={v.avatar} alt="" loading="lazy" className="w-9 h-9 rounded-full bg-white/10"/>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold truncate">{v.name || v.username}</div>
                    <div className="text-[11px] text-white/50 truncate">@{v.username}{v.hifi_id ? ` · ID ${v.hifi_id}` : ""}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
